"use client";

import dynamic from "next/dynamic";
import type { OmniboxDeveloperProps } from "./OmniboxDeveloper";

const OmniboxDeveloper = dynamic(() => import("./OmniboxDeveloper").then(mod => mod.OmniboxDeveloper));

export const OmniboxDeveloperWrapper = (props: OmniboxDeveloperProps) => {
  return <OmniboxDeveloper {...props} />;
};

export default OmniboxDeveloperWrapper;
